var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BravadoText',{staticClass:"import-contacts-button",attrs:{"tag":"button","variant":"body-semibold"}},[_vm._t("icon"),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }